import React from "react";
import { View, Text } from "react-native";

export function Loading() {
  return (
    <View>
      <Text>Loading</Text>
    </View>
  );
}
